import React from 'react'
import GalleryHero from './GalleryHero'
import GallerySection from './GallerySection'
import GalleryCollage from './GalleryCollage'

const Gallery = () => {
  return (
    <div>
        <GalleryHero/>
        <GalleryCollage/>
      <GallerySection/>
    </div>
  )
}

export default Gallery